export default __webpack_public_path__ + "static/media/facebook.6207b14b.svg";